import React from "react";
import "./Stats.css";

const Stats = ({ stats }) => {
  const getProgressPercentage = () => {
    if (stats.total === 0) return 0;
    return (((stats.contacted + stats.deleted) / stats.total) * 100).toFixed(1);
  };

  return (
    <div className="stats-container">
      <h2>Progreso</h2>
      <div className="stats-grid">
        <div className="stat-item total">
          <span className="stat-number">{stats.total}</span>
          <span className="stat-label">Total</span>
        </div>
        <div className="stat-item pending">
          <span className="stat-number">{stats.pending}</span>
          <span className="stat-label">Pendientes</span>
        </div>
        <div className="stat-item contacted">
          <span className="stat-number">{stats.contacted}</span>
          <span className="stat-label">Contactados</span>
        </div>
        <div className="stat-item deleted">
          <span className="stat-number">{stats.deleted}</span>
          <span className="stat-label">Borrados</span>
        </div>
      </div>
      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${getProgressPercentage()}%` }}
        ></div>
      </div>
      <p className="progress-text">{getProgressPercentage()}% completado</p>
    </div>
  );
};

export default Stats;
